import React, { Dispatch, SetStateAction } from 'react';
import { ContentTemplate, SectionHeader, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import AeisExamFee from './AeisExamFee';
import SpersExamFee from './SpersExamFee';
import { useGetUserAuthorities } from '../../../../api-refactored/user/useGetUserAuthorities';
import { existInArray } from '../../../../utils/ArrayUtils';

interface ExamFeeProps {
  selectedExamTypeUuid: string;
  selectedExamTypeDisplay?: string;
  isAeisExam: boolean;
  setNoAccess: Dispatch<SetStateAction<boolean>>;
}

export interface ExamFeeAccessControl {
  hasCreateAccess: boolean;
  hasEditAccess: boolean;
  hasDeleteAccess: boolean;
}

const ExamFee = ({
  selectedExamTypeUuid,
  selectedExamTypeDisplay,
  isAeisExam,
  setNoAccess,
}: ExamFeeProps) => {
  const { t } = useTranslation();

  const authorities = useGetUserAuthorities();
  const accessControl: ExamFeeAccessControl = {
    hasCreateAccess: existInArray(authorities.data, AUTHORITY_NAMES.CP_ADMIN_EXAM_FEES_CREATE),
    hasEditAccess: existInArray(authorities.data, AUTHORITY_NAMES.CP_ADMIN_EXAM_FEES_EDIT),
    hasDeleteAccess: existInArray(authorities.data, AUTHORITY_NAMES.CP_ADMIN_EXAM_FEES_DELETE),
  };

  return (
    <ContentTemplate type="full">
      <SectionHeader
        title={`${selectedExamTypeDisplay} ${t('exam->>ExamFeeConfiguration.ExamFees')}`}
      />
      <Typography>{t('exam->>ExamFeeConfiguration.ExamFeeStatement')} </Typography>

      {isAeisExam ? (
        <AeisExamFee
          selectedExamTypeUuid={selectedExamTypeUuid}
          setNoAccess={setNoAccess}
          accessControl={accessControl}
        />
      ) : (
        <SpersExamFee
          selectedExamTypeUuid={selectedExamTypeUuid}
          setNoAccess={setNoAccess}
          accessControl={accessControl}
        />
      )}
    </ContentTemplate>
  );
};

export default ExamFee;
